<template>
  <a class="panel-block album">
    <span class="panel-icon">
      <font-awesome-icon icon="compact-disc"></font-awesome-icon>
    </span>
    {{ album.name }}
  </a>
</template>

<script>
export default {
  name: 'Album',
  props: {
    album: {
      type: Object,
      default () {
        return {};
      }
    }
  }
};
</script>

<style scoped>
.album {
  padding-left: 72px;
  border-top-width: 0px !important;
}
</style>
